/**
 * @fileoverview O card do link (o que a API pública devolve, campo a campo) no
 * formato que o KanbanCard lê, para o quadro compartilhado usar o mesmo card
 * do CRM. Os campos que o link não mostra simplesmente não vêm da API.
 */

export const toKanbanLead = (card) => {
  const fields = card.fields.map((field) => ({ ...field, showOnCard: true }));
  // Só o progresso das subtarefas (feitas/total): os itens não vêm na lista.
  if (card.checklist) {
    fields.push({
      id: "__checklist",
      type: "checklist",
      showOnCard: false,
      items: Array.from({ length: card.checklist.total }, (_, i) => ({ done: i < card.checklist.done })),
    });
  }
  return {
    id: card.id,
    statusId: card.column,
    name: card.name,
    priority: card.priority,
    createdAt: card.createdAt,
    phone: card.phone,
    serviceOrder: card.serviceOrder,
    // O filtro de responsável do Kanban compara pelo id; aqui, pelo nome.
    assignedUserId: card.assignee,
    assignedUser: card.assignee ? { name: card.assignee } : null,
    customFields: {
      slaDate: card.dueAt || undefined,
      produto_interesse: card.products.length ? card.products.join(", ") : undefined,
      fields,
    },
  };
};

/** Os cards do quadro agrupados pela etapa, na ordem da API. */
export const groupByColumn = (cards) =>
  cards.reduce((groups, card) => {
    const lead = toKanbanLead(card);
    (groups[lead.statusId] = groups[lead.statusId] || []).push(lead);
    return groups;
  }, {});
